import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import tick from "../Assets/failed.gif";

const recoverySteps = [
  {
    icon: "bi-arrow-repeat",
    title: "Try the booking again",
    text: "Temporary payment interruptions can happen. A fresh retry usually fixes it in a moment.",
  },
  {
    icon: "bi-wallet2",
    title: "Check payment method",
    text: "Make sure your bank, UPI app, or card has enough balance and has not timed out during the payment step.",
  },
  {
    icon: "bi-headset",
    title: "Need quick help?",
    text: "Our team can help you complete the booking smoothly if the issue continues.",
  },
];

const Failed = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <section className="booking-success-page booking-failed-page">
        <div className="booking-success-page__orb booking-success-page__orb--one" />
        <div className="booking-success-page__orb booking-success-page__orb--two" />

        <div className="booking-failed-layout">
          <section className="booking-success-hero booking-failed-hero">
            <div className="booking-success-hero__badge booking-failed-hero__badge">
              Payment Unsuccessful
            </div>
            <img
              className="booking-success-hero__tick booking-failed-hero__visual"
              src={tick}
              alt="Payment failed"
            />
            <h1>Your booking was not completed this time.</h1>
            <p>
              We could not confirm the payment, so the booking has not been
              locked in yet. You can retry the process right away or reach out
              to our team if you want help finishing it quickly.
            </p>

            <div className="booking-success-hero__actions">
              <button
                type="button"
                onClick={() => navigate("/booknow")}
                className="complete-btn booking-success-hero__home booking-failed-hero__primary"
              >
                Try Booking Again
              </button>
              <button
                type="button"
                className="booking-success-hero__secondary booking-failed-hero__secondary"
                onClick={() => navigate("/contact")}
              >
                Contact Support
              </button>
            </div>
          </section>

          <section className="booking-failed-panel">
            <div className="booking-failed-panel__eyebrow">What You Can Do</div>
            <h2>Quick ways to finish your celebration booking without stress.</h2>

            <div className="booking-failed-panel__grid">
              {recoverySteps.map((step) => (
                <article key={step.title} className="booking-failed-tip">
                  <div className="booking-failed-tip__icon">
                    <i className={`bi ${step.icon}`} />
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>

            <div className="booking-failed-panel__note">
              <strong>Tip:</strong> if money has been deducted but your booking
              is still not confirmed, contact us before retrying so we can
              verify the transaction for you.
            </div>
          </section>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Failed;
